import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  required?: boolean;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  required,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-151">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-152">
            {label}
            {required && <span className="text-[#FF3B30] ml-1" data-id="element-153">*</span>}
          </label>}
        <input ref={ref} className={`w-full px-4 py-2 border ${error ? 'border-[#FF3B30]' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30] transition-colors ${className}`} {...props} data-id="element-154" />
        {error && <p className="mt-1 text-sm text-[#FF3B30]" data-id="element-155">{error}</p>}
      </div>;
});
Input.displayName = 'Input';